// UsernameTag.jsx
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { SanitizedLink as Link } from '../component/SanitizedLink.jsx';

class UsernameTag extends Component {
  componentDidMount() {
    const { userId, username, fetchUserByUsername } = this.props;

    if (!userId) {
      fetchUserByUsername(username);
    }
  }
  render() {
    const { username, userId, error } = this.props;

    if (error || !userId) {
      return `@${username}`;
    }

    return <UsernameStyled to={`/user/${userId}`}>@{username}</UsernameStyled>;
  }
}

UsernameTag.propTypes = {
  userId: PropTypes.string,
  username: PropTypes.string.isRequired,
  error: PropTypes.any,
  fetchUserByUsername: PropTypes.func,
};

UsernameTag.defaultProps = {
  userId: null,
  fetchUserByUsername: () => null,
};

const UsernameStyled = styled(Link)`
  color: #00d2be;
  font-size: inherit;
  font-weight: inherit;
`;

export default UsernameTag;
